/**
 * NC-1722: typed failure of a browser → Blob Storage PUT (SAS upload).
 *
 * The PUT goes by XMLHttpRequest straight to `*.blob.core.windows.net`, so the
 * shared apiClient interceptor never sees it — a 403 from the storage account
 * stayed invisible under Feedback-und-Fehler (live: `Workshop-Kit.zip`,
 * 2026-10-30, Lauf D2FA9CD8). This error carries what the reporter needs,
 * status + request URL, and strips the SAS query string up front: a SAS is a
 * bearer credential and must never land in a report.
 */
export class UploadHttpError extends Error {
  /** HTTP status of the PUT; 0 when the request never completed (network). */
  readonly status: number;
  /** Blob URL without query string or fragment (origin + path only). */
  readonly requestUrl: string;

  constructor(status: number, uploadUrl: string, message: string) {
    super(message);
    this.name = 'UploadHttpError';
    this.status = status;
    this.requestUrl = stripUrlQuery(uploadUrl);
    // Keep `instanceof` working when the build target downlevels classes.
    Object.setPrototypeOf(this, UploadHttpError.prototype);
  }
}

/** Drop everything from the first `?` or `#` on — the SAS lives in the query. */
export function stripUrlQuery(url: string): string {
  const query = url.indexOf('?');
  const bare = query >= 0 ? url.slice(0, query) : url;
  const hash = bare.indexOf('#');
  return hash >= 0 ? bare.slice(0, hash) : bare;
}
